import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';

export default class SamlConfigApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async delete(): Promise<any> {
    return super.delete(api.delete_saml_configurations, {});
  }
}
